import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/constants/site";

const EASE = [0.22, 1, 0.36, 1];

/**
 * FinalCTA — reimagined as an editorial closing statement.
 * Deep navy · single wide statement · CTAs anchored on the right.
 */
export default function FinalCTA() {
  return (
    <section
      id="contato"
      data-testid="final-cta"
      className="relative env-ink py-24 md:py-32 overflow-hidden"
    >
      {/* Ambient depth */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 15% 20%, rgba(0,194,209,0.12) 0%, transparent 60%), radial-gradient(ellipse 50% 40% at 85% 80%, rgba(46,229,157,0.10) 0%, transparent 60%), linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(0,0,0,0.25) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-px bg-white/15"
      />

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <motion.span
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5 }}
              className="text-[11px] font-medium tracking-[0.24em] uppercase text-[#2EE59D] block"
            >
              Vem fazer parte desse movimento
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE, delay: 0.08 }}
              className="mt-4 font-display text-white text-[36px] sm:text-[46px] md:text-[58px] lg:text-[64px] leading-[0.98] tracking-[-0.02em] max-w-4xl"
            >
              O propósito da licito.guru é{" "}
              <span
                className="bg-clip-text text-transparent"
                style={{
                  backgroundImage: "linear-gradient(90deg, #00C2D1 0%, #2EE59D 100%)",
                }}
              >
                vencer a insegurança jurídica e a burocracia
              </span>{" "}
              nas licitações e nos contratos.
            </motion.h2>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE, delay: 0.2 }}
            className="lg:col-span-4 flex flex-col items-start gap-3 lg:pb-3"
          >
            <a
              data-testid="final-cta-primary"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-between gap-3 px-6 py-4 bg-white text-[#1A3A61] font-medium text-[15px] hover:bg-[#2EE59D] transition-colors"
            >
              Testar grátis
              <ArrowRight size={16} strokeWidth={2} />
            </a>
            <a
              data-testid="final-cta-secondary"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-between gap-3 px-6 py-4 border border-white/25 text-white font-medium text-[15px] hover:bg-white/5 transition-colors"
            >
              Agendar Demonstração
              <MessageCircle size={16} strokeWidth={2} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
